import React, {useState} from "react";
import styles from './FJPhotoItem.module.less';
import FJImage from "fj-components/FJImage";
import FJLocalStore from "../../../../../store/FJLocalStore";
import FJAddButton from "../FJAddButton";
import classNames from 'classnames';

function FJPhotoItem(props) {

	const {selected, x, y, width, height, userHtml, userName, id, keywords, format, url, fullUrl, description, originWidth, originHeight} = props;
	const {onSubmit, onPreview,} = props;
	const [status, updateStatus] = useState('error');
	const _addStock = (e) => {
		e.stopPropagation();
		onSubmit(id, selected, fullUrl, {thumbnail: url, name: description});
	};
	const _handleClick = () => {
		onPreview({
			id,
			selected,
			title: description,
			keywords,
			thumbnail: url,
			format,
			originWidth,
			originHeight,
			url: fullUrl,
			headerTitle: FJLocalStore._('preview-photo'),
			type: 'image',
			isAddToLibrary: selected,
		})
	};
	const _link = (e) => {
		e.stopPropagation();
	};

	return (
		<li className={styles.li_box}
		    style={{left: x, top: y, width, height}}
		>
			<div className={styles.list_content}>
				<FJImage url={url} imgAdapt='cover' setImgLoadStatus={updateStatus}/>
				{
					status === 'success' &&
					<div className={classNames(styles.mask_layer, {[styles.selected]: selected})} onClick={_handleClick}>
						<div className={styles.photo_info}>
							<span>{FJLocalStore._('photo by')}</span>
							<a onClick={_link} target='_blank' href={userHtml}>{userName}</a>
							<span>{FJLocalStore._('on')}</span>
							<a onClick={_link} target='_blank' href='https://unsplash.com/'>{FJLocalStore._('unsplash')}</a>
						</div>
						<FJAddButton onClick={_addStock} selected={selected} className={styles.add_btn}/>
					</div>
				}
			</div>
		</li>
	)

}

export default FJPhotoItem;